angular.module('tasks')
    .service('TaskCalendarV4Service', function ($rootScope, $compile, TaskService, NoteService, Principal, LeaveService) {
        let handleTaskClick = function (info) {
            return TaskService.showModal(info.event.id);
        }
        let handleNoteClick = function (info) {
            if (!Principal.hasAnyAuthority(['ROLE_NOTES'])) return;
            return NoteService.showModal(info.event.id);
        }
        let handleLeaveClick = function (info) {
            let leave = {
                id: info.event.id,
                start: info.event.start,
                end: info.event.end,
                startDate: info.event.extendedProps.startDate,
                endDate: info.event.extendedProps.endDate,
                user: info.event.extendedProps.user,
                numberOfDays: info.event.extendedProps.numberOfDays,
            }
            return LeaveService.openOfEvent(leave);
        }
        const eventClickHandlers = {
            TASK: handleTaskClick,
            NOTE: handleNoteClick,
            LEAVE: handleLeaveClick
        };

        this.eventClick = info => {
            const model = info.event.extendedProps.model;
            const handler = eventClickHandlers[model];

            if (handler) {
                handler(info);
            } else {
                console.warn(`No handler for event type: ${model}`);
            }
        };
        this.eventDrop = (info) => {
            const model = info.event.extendedProps.model;
            if (model !== 'TASK') {
                console.warn(`Event drop not supported for model: ${model}`);
                info.revert();
                return;
            }
            let period = {
                startTime: info.event.start
            }
            if(info.event.end === null){
                let end = moment(info.event.start);
                period.endTime = info.event.allDay ? end.add(1, 'd') : end.add(1, 'h');
            }
            else{
                period.endTime = info.event.end;
            }
            TaskService.editPeriodModal(info.event.id, period).catch(info.revert);
        };
        this.select = (info) => {
            TaskService.addModal({startTime: info.start, endTime: info.end});
        };
        this.eventResize = (info) => {
            const model = info.event.extendedProps.model;
            if (model !== 'TASK') {
                console.warn(`Event resize not supported for model: ${model}`);
                info.revert();
                return;
            }
            let period = {
                startTime: info.event.start,
                endTime: info.event.end
            };
            TaskService.editPeriodModal(info.event.id, period).catch(info.revert);
        };

        this.eventRender = (info) => {
            let element = info.el;
            let event = info.event;

            function userAttendanceIcon(attendanceListStatistics) {
                if (!attendanceListStatistics || !attendanceListStatistics.userOnList)
                    return;

                let currentStatusClass = "WAITING";
                if (attendanceListStatistics.userStatus)
                    currentStatusClass = attendanceListStatistics.userStatus;

                return "<i class='fa fa-check-circle-o attendance-" + currentStatusClass + "'></i>&nbsp;";
            }

            function attendanceListIcon(attendanceListStatistics) {
                let isUserTaskSuperuser = Principal.hasAnyAuthority(["ROLE_TASKS_SUPERUSER"])
                if (!attendanceListStatistics || isUserTaskSuperuser === false)
                    return;

                let allAccepted = attendanceListStatistics.acceptedCount === attendanceListStatistics.listCount;
                let someoneRejected = attendanceListStatistics.rejectedCount > 0;
                let someoneNoted = attendanceListStatistics.notedCount > 0;
                let iconClass = '';
                if (allAccepted)
                    iconClass = 'attendance-ACCEPTED';
                else if (someoneRejected)
                    iconClass = 'attendance-REJECTED';
                else if (someoneNoted)
                    iconClass = 'attendance-NOTED';

                return "<i class='fa fa-users " + iconClass + "'></i>&nbsp;";
            }

            let content = "";
            if (event.extendedProps.attendanceRequired) {
                let userIcon = userAttendanceIcon(event.extendedProps.attendanceListStatistics);
                if(userIcon){
                    content += userIcon;
                }
                let listIcon = attendanceListIcon(event.extendedProps.attendanceListStatistics);
                if(listIcon){
                    content += listIcon;
                }
            }
            content += event.title;
            let titleElement = element.querySelector('.fc-title');
            if(titleElement)
                titleElement.innerHTML = content;

            let listTitleElement = element.querySelector('.fc-list-item-title');
            if(listTitleElement)
                listTitleElement.innerHTML = content;


            let title= event.extendedProps.companies == null ? event.title : (event.extendedProps.companies + " - " + event.title);
            element.setAttribute("title", title);
        };
        this.defaultConfig = (element, options) => {
            let isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent));
            let height = isMobile ? "auto" : 850;
            let defaultOptions = {
                plugins: ['dayGrid', 'timeGrid', 'list', 'interaction'],
                header: {left: 'today, prev,next', center: 'title', right: 'dayGridMonth,timeGridWeek,listDay'},
                defaultView: "timeGridWeek",
                locale: 'pl',
                weekNumbers: true,
                businessHours: {
                    dow: [1, 2, 3, 4, 5],
                    start: '8:00',
                    end: '17:00',
                },
                height: height,
                displayEventTime: true,
                displayEventEnd: true,
                eventTimeFormat: {
                    hour: '2-digit',
                    minute: '2-digit',
                    meridiem: false
                },
                eventRender: this.eventRender,
                eventClick: this.eventClick,

                editable: true,

                droppable: true,
                eventDrop: this.eventDrop,

                eventResizableFromStart: true,
                eventDurationEditable: true,
                eventResize: this.eventResize,

                selectable: true,
                // selectAllow: this.selectAllow,
                select: this.select,

                // dateClick: this.dateClick,
            };
            angular.extend(defaultOptions, options);
            return defaultOptions;
        }
    })
